
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import Slider from './filters/Slider';
import Checkbox from './filters/Checkbox';
import Radio from './filters/Radio';
import { ToggleSwitchWithLabel } from './filters/ToggleSwitch';
import Increment from './filters/Increment';
import Dropdown from './filters/Dropdown';

import styles from './styles.js';

const Filter = ({
    changeButtonText,
    columns = 1,
    filter,
    filterGroup,
    filterGroupCollectionIndex,
    filterGroupIndex,
    filterIndex,
    handleFilterChange,
    handleSliderChange,
    isDisabled,
    lang,
    noContainer
}) => {
    let element;
    switch (filterGroup.inputType) {
    case 'slider': {
        element = (
            <div className={css(styles.colMd12)}>
                <Slider
                    changeButtonText={changeButtonText}
                    filter={filter}
                    filterIndex={filterIndex}
                    filterGroup={filterGroup}
                    filterGroupCollectionIndex={filterGroupCollectionIndex}
                    filterGroupIndex={filterGroupIndex}
                    handleSliderChange={handleSliderChange}
                    id={`slider-filter_${filterIndex}-${filterGroupIndex}-${filterGroupCollectionIndex}`}
                />
            </div>
        );
        break;
    }
    case 'radio': {
        element = (
            <div className={css(styles.colMd12)}>
                <Radio
                    checked={filter.data.value}
                    filterIndex={filterIndex}
                    filterGroupIndex={filterGroupIndex}
                    filterGroupCollectionIndex={filterGroupCollectionIndex}
                    handleRadioChange={handleFilterChange}
                    id={`radio-filter_${filterIndex}-${filterGroupIndex}-${filterGroupCollectionIndex}`}
                    label={filter.title}
                    name={filter.title}
                    value={filter.value}
                />
            </div>
        );
        break;
    }
    case 'toggle-switch': {
        element = (
            <div className={css(styles.colMd12)}>
                <ToggleSwitchWithLabel
                    filterIndex={filterIndex}
                    filterGroupIndex={filterGroupIndex}
                    filterGroupCollectionIndex={filterGroupCollectionIndex}
                    handleFilterChange={handleFilterChange}
                    id={`toggle-filter_${filterIndex}-${filterGroupIndex}-${filterGroupCollectionIndex}`}
                    label={filter.title}
                    name={filter.title}
                    subtitle={filter.subtitle}
                    value={filter.data.value}
                />
            </div>
        );
        break;
    }
    case 'increment': {
        element = (
            <div className={css(styles.colMd12)}>
                <Increment
                    emitValue={handleFilterChange}
                    filterIndex={filterIndex}
                    filterGroupIndex={filterGroupIndex}
                    filterGroupCollectionIndex={filterGroupCollectionIndex}
                    id={`increment-filter_${filterIndex}-${filterGroupIndex}-${filterGroupCollectionIndex}`}
                    incrementValue={filter.incrementValue}
                    label={filter.title}
                    legendText={filter.subtitle}
                    value={filter.data.value}
                    unit={filter.data.unit}
                    isDisabled={isDisabled}
                    lang={lang}
                />
            </div>
        );
        break;
    }
    case 'dropdown': {
        element = (
            <div className={css(styles.colMd12)}>
                <Dropdown
                    filter={filter}
                    filterIndex={filterIndex}
                    filterGroup={filterGroup}
                    filterGroupCollectionIndex={filterGroupCollectionIndex}
                    filterGroupIndex={filterGroupIndex}
                    handleFilterChange={handleFilterChange}
                    isDisabled={isDisabled}
                />
            </div>
        );
        break;
    }
    default:
        if (columns > 1) {
            const className = `colMd${12 / columns}`;
            element = (
                <div className={css(styles[className])}>
                    <Checkbox
                        columns={columns}
                        filter={filter}
                        filterIndex={filterIndex}
                        filterGroup={filterGroup}
                        filterGroupCollectionIndex={filterGroupCollectionIndex}
                        filterGroupIndex={filterGroupIndex}
                        handleCheckboxChange={handleFilterChange}
                    />
                </div>
            );
        } else {
            element = (
                <div className={css(styles.colMd12)}>
                    <Checkbox
                        filter={filter}
                        filterIndex={filterIndex}
                        filterGroup={filterGroup}
                        filterGroupCollectionIndex={filterGroupCollectionIndex}
                        filterGroupIndex={filterGroupIndex}
                        handleCheckboxChange={handleFilterChange}
                    />
                </div>
            );
        }
        break;
    }
    if (noContainer) {
        return element;
    }
    if (columns > 1) {
        return element;
    }
    return (
        <div className={css(styles.filterContainer)}>
            {element}
        </div>
    );
};

Filter.propTypes = {
    changeButtonText: PropTypes.func,
    columns: PropTypes.number,
    filter: PropTypes.object.isRequired,
    filterGroup: PropTypes.object.isRequired,
    filterGroupCollectionIndex: PropTypes.number.isRequired,
    filterGroupIndex: PropTypes.number.isRequired,
    filterIndex: PropTypes.number.isRequired,
    handleFilterChange: PropTypes.func.isRequired,
    handleSliderChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    lang: PropTypes.object.isRequired,
    noContainer: PropTypes.bool
};

Filter.defaultProps = {
    isDisabled: false
};

export default Filter;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/Filter.jsx